import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';
import CircularProgress from '@material-ui/core/CircularProgress';
import Label from 'globalcomponents/UI/FormLabel/Clutch';
import Message from 'globalcomponents/UI/Message/Clutch';
import Button from 'globalcomponents/UI/Button/Clutch';
import SubHeader from 'globalcomponents/SubHeader/Clutch';
import { pageUrls } from 'globalconfig/constants/keys';
import { getMediaPath, mediaUrls } from 'globalconfig/constants/mediaUrls';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window.$environment?.CURRENT_LAYOUT;
const Input = lazy(() => import(`globalcomponents/UI/Input/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`).default;

const RenderComponent = ({ values, handleEdit, errors, isNotValid, validateForm, customProps, submitAction }) => {
  const { i18n } = useTranslation();
  const NewUI = checkServiceProvider('newUi', window.$environment.SERVICE_PROVIDER, false);
  return (
    <>
      <customProps.Styled.LoginHeader>
        <img alt="logo" src={getMediaPath(mediaUrls.clutchLogo, true)} className="ClutchLogo"></img>
        {!NewUI && (
          <>
            <SubHeader variant="h2" text={i18n.t('Forgot')} mode="light" className="loginHeader" />
            <p className="subHeading">{i18n.t('ForgotHeading')}</p>
          </>
        )}
      </customProps.Styled.LoginHeader>
      <customProps.Styled.LoginContent newUI={NewUI}>
        {NewUI && (
          <>
            <SubHeader variant="h2" text={i18n.t('Forgot')} mode="dark" className="loginHeader" />
            <p className="subHeading">{i18n.t('ForgotHeading')}</p>
          </>
        )}
        {customProps?.hasApiStatus?.errorMessage && (
          <customProps.Styled.LoginError>
            <Message type="error" message={i18n.t(customProps.hasApiStatus.errorMessage)} />
          </customProps.Styled.LoginError>
        )}
        <customProps.Styled.userNameWrapper>
          <FormStyle.FieldsWrapper width="100%">
            <Label variant="body1">{i18n.t('emailAddress')}</Label>
            <FormStyle.TextWrapper>
              <Field
                name="email"
                handleOnChange={(event) => handleEdit(event, { field: 'email', type: 'email' })}
                as={Input}
                placeholder={i18n.t('Username or Email')}
                value={values.email}
                type="email"
                mode="light"
              />
              {errors['email'] && !isNotValid && <Message type="error" message={errors['email']} />}
            </FormStyle.TextWrapper>
          </FormStyle.FieldsWrapper>
        </customProps.Styled.userNameWrapper>
        <customProps.Styled.LoginButtonWrapper newUI={NewUI}>
          <FormStyle.ButtonsWrapper>
            <Button
              type="submit"
              label={customProps?.hasApiStatus?.isLoading ? <CircularProgress color="inherit" /> : i18n.t('common.resetPassword')}
              onClick={() => {
                const validateResponse = validateForm();
                validateResponse.then((data) => submitAction(data));
              }}
              id="forgotPasswordButton"
            />
          </FormStyle.ButtonsWrapper>
        </customProps.Styled.LoginButtonWrapper>
        <customProps.Styled.registerSection>
          <a href={pageUrls.login} className="linkToregister">
            {i18n.t('backLogin')}
          </a>
        </customProps.Styled.registerSection>
      </customProps.Styled.LoginContent>
      {NewUI && <span className="patentText">{i18n.t('footer.copyright')}</span>}
    </>
  );
};

export default RenderComponent;

RenderComponent.propTypes = {
  values: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  isNotValid: PropTypes.bool.isRequired,
  customProps: PropTypes.object,
  validateForm: PropTypes.func.isRequired,
  submitAction: PropTypes.func.isRequired,
};
